import { computed } from 'vue'
import useAuthStore from '~/stores/auth'
import { GradeType } from '~/models/GradeType'

export function useWebshopUrl() {
  const store = useAuthStore()
  const webshopUrl = computed(() => {
    switch (store.selectedGradeType) {
      case GradeType.Grade1To4:
      case GradeType.Grade5To7: {
        return import.meta.env.VITE_WEBSHOP_BARNESKOLE as string
      }

      case GradeType.Grade8To10: {
        return import.meta.env.VITE_WEBSHOP_UNGDOMSSKOLE as string
      }

      case GradeType.GradeVgs: {
        return import.meta.env.VITE_WEBSHOP_VGS as string
      }

      default: {
        return import.meta.env.VITE_WEBSHOP_SITEURL as string
      }
    }
  })

  return {
    webshopUrl
  }
}
